module.exports = "<span class=\"disable-select\" (click)=\"paint()\">{{tileDisplay}}</span>\n"